//This file is generated from c# do not modify, any changes will be overridden when re-generated.
import { ModelBase } from "../../pillar/common/models/ModelBase";
import { ExtractModel } from './ExtractModel';
import { CalOmsExtractWorkspaceFilterModel } from './CalOmsExtractWorkspaceFilterModel';
  
export class ExtractPageViewModel extends ModelBase {
  static readonly $typeName = 'ExtractPageViewModel';
  public model: ExtractModel;
  public filterModel: CalOmsExtractWorkspaceFilterModel;
      public page: number;
      public pageSize: number;
      public searchTerm: string;
      public skip: number;
      public sort: string;
      public sortDirection: string;
      public take: number;
      public extractType: string;
      public extractCategoryName: string;
  }



// WEBPACK FOOTER //
// ./src/app/extracts/models/ExtractPageViewModel.ts